import type { RedirectEntry } from '@frontend/types/adminhub';
import { URL_ROLES } from '@frontend/config/serviceUrlRegistry';

interface RedirectRegistryTableProps {
  entries: RedirectEntry[];
}

function UrlCell({ url }: { url: string | null | undefined }) {
  if (!url) {
    return <span className="redirect-url-none">—</span>;
  }
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="redirect-url-link">
      {url}
    </a>
  );
}

export default function RedirectRegistryTable({ entries }: RedirectRegistryTableProps) {
  return (
    <div className="container-stats-wrapper">
      <table className="container-stats-table redirect-registry-table">
        <thead>
          <tr>
            <th className="redirect-col-service">Service</th>
            <th>Auth Model</th>
            <th>KC Client</th>
            <th>Public</th>
            <th>Admin</th>
            <th>API</th>
            <th>Entry / Launch</th>
            <th>Callback</th>
            <th>Registered Redirect URIs</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((entry) => (
            <tr key={entry.id || entry.service}>
              <td className="container-name redirect-col-service">{entry.service}</td>
              <td><code>{entry.authModel}</code></td>
              <td>{entry.keycloakClientId ? <code>{entry.keycloakClientId}</code> : <span className="redirect-url-none">—</span>}</td>
              <td><UrlCell url={entry.roleUrls?.public} /></td>
              <td><UrlCell url={entry.roleUrls?.admin} /></td>
              <td><UrlCell url={entry.roleUrls?.api} /></td>
              <td><UrlCell url={entry.entryUrl || entry.roleUrls?.launch || entry.roleUrls?.sso_entry} /></td>
              <td><UrlCell url={entry.callbackUrl || entry.roleUrls?.callback} /></td>
              <td>
                {entry.keycloakRegisteredRedirectUris.length ? (
                  <ul className="redirect-uri-list">
                    {entry.keycloakRegisteredRedirectUris.map((uri) => (
                      <li key={uri}><code>{uri}</code></li>
                    ))}
                  </ul>
                ) : (
                  <span className="redirect-url-none">—</span>
                )}
                {entry.paths && Object.keys(entry.paths).length > 0 ? (
                  <details className="redirect-paths-details">
                    <summary>All roles</summary>
                    <ul className="redirect-uri-list">
                      {URL_ROLES.filter((r) => entry.paths[r]).map((role) => (
                        <li key={role}>
                          <code>{role}</code>: <UrlCell url={entry.roleUrls[role]} />
                        </li>
                      ))}
                    </ul>
                  </details>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
